module.exports = __webpack_public_path__ + "img/LU.9c7aa05e.png";